import { createContext, useContext, useState, useEffect } from 'react';
import { useBranch } from './BranchContext';
import api from '../utils/api';

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const { activeBranch } = useBranch();
  const [subscriptionRequired, setSubscriptionRequired] = useState(false);
  const [subscriptionActive, setSubscriptionActive] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!activeBranch?.branch_id) {
        setLoading(false);
        return;
      }
      
      try {
        const res = await api.get(`/billing/subscription/status/${activeBranch.branch_id}`);
        setSubscriptionRequired(res.data?.subscription_required || false);
        
        // Check if subscription is active or not required
        const status = res.data?.subscription_status;
        setSubscriptionActive(
          !res.data?.subscription_required || 
          status === 'active' || 
          status === 'grace_period' ||
          status === 'not_required'
        );
      } catch (err) {
        console.error('Subscription check failed:', err);
        // If endpoint fails, assume no subscription required
        setSubscriptionRequired(false);
        setSubscriptionActive(true);
      }
      
      setLoading(false);
    };
    
    checkSubscription();
  }, [activeBranch?.branch_id]);

  return (
    <SubscriptionContext.Provider value={{ subscriptionRequired, subscriptionActive, loading }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
};
